import { Box, Button, Divider, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { StyledSaveToHomePageModal } from './style';
import { useEffect } from 'react';

interface SaveToHomePageProps {
    publisherStoreLogo: string;
    publisherStoreName: string;
    isDarkMode: boolean;
    onClick: () => void;
    isAndroid: boolean;
    handleInstallApp: any;
}

const SaveToHomePage = ({
    publisherStoreLogo,
    publisherStoreName,
    isDarkMode,
    onClick,
    isAndroid,
    handleInstallApp
}: SaveToHomePageProps) => {
    useEffect(() => {
        document.documentElement.setAttribute(
            'data-theme',
            isDarkMode ? 'dark' : 'light'
        );
    }, [isDarkMode]);
    return (
        <StyledSaveToHomePageModal>
            <Box className="container">
                <IconButton className="close-button" onClick={onClick}>
                    <CloseIcon className="close-button--icon" />
                </IconButton>
                <Box className="company-info">
                    <Box>
                        <img
                            className="company-info--logo"
                            alt="publisher-logo"
                            src={publisherStoreLogo}
                        />
                        <h2 className="company-info--title">
                            {publisherStoreName}
                        </h2>
                        <p className="company-info--description">
                            Install {publisherStoreName} to get the latest
                            deals!
                        </p>
                    </Box>
                    {isAndroid && (
                        <Button
                            className="company-info--button"
                            onClick={handleInstallApp}
                        >
                            Install
                        </Button>
                    )}
                </Box>
                {!isAndroid && (
                    <Box className="guide">
                        <Divider className="guide-divider" />
                        <p className="guide-description">
                            This site has app functionality. Add it to your Home
                            Screen for extensive experience and easy access
                        </p>
                        <Divider className="guide-divider" />
                        <ul className="guide-list">
                            <li className="guide-list--item">
                                <div className="guide-list--item__icon">
                                    <img
                                        src="https://media.appcharge.com/defaults/safari-apple-icon.svg"
                                        alt="safari icon"
                                    />
                                </div>
                                1. Open in Safari browser
                            </li>
                            <li className="guide-list--item">
                                <div className="guide-list--item__icon">
                                    <img
                                        src="https://media.appcharge.com/defaults/share-apple-icon.svg"
                                        alt="share icon"
                                    />
                                </div>
                                2. Press Share in Navigation bar
                            </li>
                            <li className="guide-list--item">
                                <div className="guide-list--item__icon">
                                    <img
                                        src={
                                            isDarkMode
                                                ? 'https://media.appcharge.com/defaults/add-dark-apple-icon.svg'
                                                : 'https://media.appcharge.com/defaults/add-apple-icon.svg'
                                        }
                                        alt="add icon"
                                    />
                                </div>
                                3. Press Add to Home Screen
                            </li>
                        </ul>
                    </Box>
                )}
            </Box>
        </StyledSaveToHomePageModal>
    );
};

export default SaveToHomePage;
